const timeDate = require('../../../../../js-handler/time-date')
const autocompleteHandler = require('../../../../../components/textfield/autocomplete-handler')
const fullcontFormHandler = require('../../../../../components/fullcont/fullcont-form-handler')

// Prepares the sections and default dates for a new transaction.
export function prepareAdd(htmlFc) {
  htmlFc.savedTransactionType = ''
  setTransactionTypeDisabled(htmlFc, false)
  syncTransactionType(htmlFc)
}

// Reutiliza el guardado del framework solo con los campos de la subentidad visible.
export function getSaveContext(htmlFc) {
  const select = htmlFc.fullcontHTML.querySelector('#transaction-type select')
  if (htmlFc.savedTransactionType) select.value = htmlFc.savedTransactionType
  return getTypeContext(htmlFc, select.value)
}

// Limita la carga o el guardado a los campos de una subentidad, sin cambiar el formulario visible.
export function getTypeContext(htmlFc, transactionType) {
  const belongsToSelection = (field) => field.name === 'transaction_type'
    || field.transactionType === transactionType

  return {
    ...htmlFc,
    form: htmlFc.form.filter(belongsToSelection),
    formCopy: htmlFc.formCopy.filter(belongsToSelection),
  }
}

// El framework ya cargo el registro y su copia; muestra su seccion y bloquea el tipo guardado.
export function afterSave(htmlFc, data, result) {
  if (result.restriction && result.restriction.val !== 'ok') return

  htmlFc.savedTransactionType = data.transaction_type
  setTransactionTypeDisabled(htmlFc, true)
  // El checkbox generico solo marca true; sincroniza tambien false al recuperar una compra.
  if (data.transaction_type === 'asset_purchase') {
    htmlFc.fullcontHTML.querySelector('#transaction-pfa-depreciationEnabled input').checked = data.pfa_depreciationEnabled === 'true'
  }
  showTransactionSection(htmlFc, data.transaction_type)
}

// Conserva los campos recien cargados y reinicia las otras secciones sin generar cambios pendientes.
export function afterSelect(htmlFc, data, result) {
  cleanTransactionFields(htmlFc, data.transaction_type)
  afterSave(htmlFc, data, result)
}

// Usa el estado disabled y la clase existente del framework, sin estilos propios.
function setTransactionTypeDisabled(htmlFc, disabled) {
  const field = htmlFc.fullcontHTML.querySelector('#transaction-type')
  field.querySelector('select').disabled = disabled
  field.classList.toggle('textfield-disabled', disabled)
}

// Cleans previous values and shows only the selected transaction section.
export function syncTransactionType(htmlFc) {
  const select = htmlFc.fullcontHTML.querySelector('#transaction-type select')
  // No limpiar el registro si llega un evento change despues de guardar.
  if (htmlFc.savedTransactionType) {
    select.value = htmlFc.savedTransactionType
    return
  }
  const transactionType = select.value

  cleanTransactionFields(htmlFc)
  // La limpieza al elegir otra subentidad borra las fechas; restablece hoy y su copia interna.
  setCurrentDate(htmlFc)
  showTransactionSection(htmlFc, transactionType)
}

// Muestra la seccion elegida sin limpiar los valores recuperados de la base de datos.
function showTransactionSection(htmlFc, transactionType) {
  syncTransactionTitle(htmlFc, transactionType)
  const sections = new Map()

  htmlFc.form.forEach((field) => {
    if (field.transactionType === undefined) return

    const section = field.html.closest('[data-transaction-section]')
    if (section !== null) sections.set(field.transactionType, section)
  })

  sections.forEach((section, type) => {
    section.classList.toggle('dn', transactionType !== type)
  })

  syncRequiredFields(htmlFc, transactionType)
  toggleAssetDepreciation(htmlFc)
}

// Actualiza los tres modos al seleccionar, cargar, guardar o actualizar una transaccion.
function syncTransactionTitle(htmlFc, transactionType) {
  const field = htmlFc.form.find((field) => field.name === 'transaction_type')
  const option = field.options.find((option) => option.value === transactionType)
  const title = option ? option.text : 'Internal Financial Transaction'

  htmlFc.fullcontHTML.querySelector('[data-transaction-title="add"]').textContent = `New - ${title}`
  htmlFc.fullcontHTML.querySelector('[data-transaction-title="view"]').textContent = title
  htmlFc.fullcontHTML.querySelector('[data-transaction-title="edit"]').textContent = `${title} - Edition`
}

// Muestra los detalles de depreciacion cuando se activa el checkbox del activo.
export function toggleAssetDepreciation(htmlFc) {
  const enabled = htmlFc.fullcontHTML.querySelector('#transaction-pfa-depreciationEnabled input').checked
  htmlFc.fullcontHTML.querySelector('#transaction-pfa-depreciationDetails').classList.toggle('dn', !enabled)

  // La configuracion completa es necesaria solo si la compra usa depreciacion.
  const requiredFields = ['pfa_depreciationMethod', 'pfa_salvageValue', 'pfa_usefulLifeMonths',
    'pfa_depreciationStartDate', 'pfa_depreciationExpenseAccount', 'pfa_monthlyDepreciation']
  const isAssetPurchase = htmlFc.fullcontHTML.querySelector('#transaction-type select').value === 'asset_purchase'
  htmlFc.form.forEach((field) => {
    if (requiredFields.includes(field.name)) field.required = isAssetPurchase && enabled
  })

  // El valor inicial permanece vacio; solo se selecciona el metodo al activar la depreciacion.
  const method = htmlFc.form.find((field) => field.name === 'pfa_depreciationMethod')
  if (enabled && fullcontFormHandler.getValues(method) === '') {
    method.value = 'Straight Line'
    fullcontFormHandler.fill(method)
  }
}

// Clears every section field while preserving the selected transaction type.
function cleanTransactionFields(htmlFc, preserveType) {
  htmlFc.form.forEach((field, index) => {
    if (field.transactionType === undefined) return
    if (field.transactionType === preserveType) return

    fullcontFormHandler.clean(field)
    field.value = fullcontFormHandler.getValues(field)

    const fieldCopy = htmlFc.formCopy[index]
    fieldCopy.value = field.value

    if (field.type !== 'autocomplete') return

    field.valueFull = []
    fieldCopy.value = []
    fieldCopy.valueFull = []

    const otherField = field.html.querySelector('.otherField')
    if (otherField !== null) otherField.setAttribute('otherField', '{}')
  })

  fullcontFormHandler.cleanRestriction(htmlFc)
}

// Copies the selected received payment data into the Bounced Check fields.
export function syncBouncedCheckReceivepayment(htmlFc) {
  const autocomplete = htmlFc.fullcontHTML.querySelector('#transaction-bc-receivepayment')
  const otherField = autocomplete.querySelector('.otherField').getAttribute('otherField')
  let receivepayment = {}

  try {
    receivepayment = otherField === null ? {} : JSON.parse(otherField)
  } catch (error) {
    receivepayment = {}
  }

  fillBouncedCheckDerivedFields(htmlFc, receivepayment)
}

// Opens a new Bounced Check transaction with a received payment preselected.
export function prepareBouncedCheck(htmlFc, receivepayment) {
  if (!receivepayment || !receivepayment.id) return

  const transactionType = htmlFc.form.find((field) => field.name === 'transaction_type')
  const receivedPayment = htmlFc.form.find((field) => field.name === 'bc_receivepayment')

  if (transactionType === undefined || receivedPayment === undefined) return

  transactionType.value = 'bounced_check'
  fullcontFormHandler.fill(transactionType)
  syncTransactionType(htmlFc)

  const otherField = {
    amount: String(receivepayment.amount || ''),
    date: String(receivepayment.date || ''),
    customer_id: String(receivepayment.customer_id || ''),
    customer_name: String(receivepayment.customer_name || ''),
    invoice_reference: String(receivepayment.invoice_reference || ''),
  }

  receivedPayment.value = [String(receivepayment.id)]
  receivedPayment.valueFull = [{
    id: String(receivepayment.id),
    displayText: String(receivepayment.displayText || ''),
    otherField,
  }]
  autocompleteHandler.fill(receivedPayment)

  fillBouncedCheckDerivedFields(htmlFc, otherField)
}

// Completa cliente, importe, fecha y codigos de facturas del pago recibido.
function fillBouncedCheckDerivedFields(htmlFc, receivepayment) {
  setTextfieldValue(htmlFc, 'bc_customer', receivepayment.customer_name || '')
  setTextfieldValue(htmlFc, 'bc_amount', receivepayment.amount || '')
  setTextfieldValue(htmlFc, 'bc_date', receivepayment.date || '')
  setTextfieldValue(htmlFc, 'bc_invoiceReference', receivepayment.invoice_reference || '')
}

// Updates one textfield in both the form model and its HTML element.
function setTextfieldValue(htmlFc, fieldName, value) {
  const field = htmlFc.form.find((element) => element.name === fieldName)

  if (field === undefined) return

  field.value = String(value)
  fullcontFormHandler.fill(field)
}

// Enables required validation only for fields in the active section.
function syncRequiredFields(htmlFc, transactionType) {
  htmlFc.form.forEach((field, index) => {
    if (field.transactionType === undefined) return

    field.required = field.transactionType === transactionType
      && htmlFc.formCopy[index].required === true
  })
}

// Applies today's date to date fields that allow automatic initialization.
function setCurrentDate(htmlFc) {
  const date = timeDate.convertDateToInput()

  htmlFc.form.forEach((field, index) => {
    if (
      field.transactionType === undefined
      || field.date !== true
      || field.setCurrentDate === false
    ) return

    field.html.querySelector('input').value = date
    field.value = date
    htmlFc.formCopy[index].value = date
  })
}
